import React from 'react'
import {
  withSitecoreContext,
  Image,
  Text,
  RichText,
} from '@sitecore-jss/sitecore-jss-react'

import {
  TextField,
  BooleanField,
  ImageField,
  Item,
  RouteFields,
} from '../../types/SitecoreAdapter'

import Footer from './Footer'
import { ContactProps, contactAdapter } from './Adapters/ContactUsAdapter'
import { FooterColumnProps, columnAdapter } from './Adapters/ColumnAdapter'
import {
  SecurityImagesProps,
  securityImagesAdapter,
} from './Adapters/SecurityImagesAdapter'
import {
  LegalLinksProps,
  legalLinksAdapter,
} from './Adapters/LegalLinksAdapter'
import {
  CopyrightProps,
  copyrightLinkAdapter,
} from './Adapters/CopyrightLinkAdapter'

type FooterProps = RouteFields<{
  enableTpFooter?: BooleanField
  contact: null | ContactProps
  footer: FooterColumnProps &
    SecurityImagesProps &
    LegalLinksProps &
    CopyrightProps &
    Item<{
      copyright: TextField
      disclaimer: TextField
      showTrustPilotWidget: BooleanField
    }>
}>

const FooterAdapter = ({
  sitecoreContext: {
    route: {
      fields: { contact, footer, enableTpFooter },
    },
  },
}: FooterProps) => {
  const contactInfo = contact && contactAdapter(contact)
  const columns = columnAdapter(footer)
  const securityImages = securityImagesAdapter(footer)
  const legalLinks = legalLinksAdapter(footer)
  const copyright = <Text field={footer.fields.copyright} />
  const copyrightLink = copyrightLinkAdapter(footer)
  const disclaimer = <RichText field={footer.fields.disclaimer} />

  const showWidget = (footer.fields.showTrustPilotWidget &&
    footer.fields.showTrustPilotWidget.value) || (enableTpFooter && enableTpFooter.value) || false

  return (
    <Footer
      contact={contactInfo || undefined}
      columns={columns}
      securityImages={securityImages}
      legalLinks={legalLinks}
      copyright={copyright}
      copyrightLink={copyrightLink || undefined}
      disclaimer={disclaimer}
      showTrustPilotWidget={showWidget}
    />
  )
}

export default withSitecoreContext()(FooterAdapter)
